import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Components from '../../../components';
import Client from '../../../services'

const headerMap = {
    "index": {label: "Sl.No.",},
    "username": {label: "User id", filter: true},
    "name": {label: "Name", filter: true},
    "address": {label: "Address", filter: true},
    "contact": {label: "Phone no", filter: true},
    "email": {label: "Email", filter: true},
    "createdAt": {label: "Created At",}
}



const StudentList = ({...props}) => {
    
    let [searchText, setSearchText] = useState("")
    var [list, setList] = useState([])
    // Component Did mount
    useEffect(async()=>{
        const {success, data} = await Client.api.get('/admin/student/list')

        if(success){
            const newList = data.map((user, i) => {
                return {
                    ...user,
                    index: i+1,
                    name: <Link to={`/admin/student/${user._id}`}>{user.name}</Link>,
                }
            })
            setList(newList)
        }else{
            setList([])
        }
    },[])

    const headers = ["index", "username", "name", "address", "createdAt"]


    return <div className="student-list">
        <h2>Student List</h2>
        <Components.input.TextInput
            className={"student-list__search-bar"}
            name="search"
            leading="Search"
            placeholder="Enter student user id, name or address"
            value={searchText}
            onChange={(e)=>setSearchText(e.target.value)}
        />

        <Components.data.Table headerMap={headerMap} headers={headers} data={list}
            containerStyle={{
                display: "flex"
            }}
            filterByValue={{
                name: searchText,
                username: searchText,
            }}
            filterByValueFunc={(data) => {
                let searchValue = searchText.toLowerCase()
                const filteredData = data.filter(v => {
                    const values = ["username", "name", "address"].map(fieldName => {
                        let value = v[fieldName];
                        if (React.isValidElement(value)) {
                            value = value.props.children
                        }
                        return value.toString().toLowerCase()
                    })
                    return values.some(value => {
                        return value.indexOf(searchValue) != -1
                    })
                })
                return filteredData;
                
            }}
        />
    </div>
}

export default StudentList